export const anchorNames = {
  references: 'references',
  science: 'the-science',
  summary: 'summary',
  whatToDo: 'what-to-do',
};

export const anchors = [
  {value: anchorNames.summary, label: 'Summary'},
  {value: anchorNames.whatToDo, label: 'What to do'},
  {value: anchorNames.science, label: 'The Science'},
  {value: anchorNames.references, label: 'References'},
];
